import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Text,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { AutoResizeTextArea } from 'components/v4/Textarea';

const NotesField = ({
    darkMode,
    values,
    setFieldValue,
    ufNotesComment,
    requiredScope,
}) => {
    const [isHovered, setIsHovered] = useState(false);

    if (requiredScope !== 80) {
        return null;
    }

    return (
        <FormControl
            sx={{ margin: '0 !important', marginBottom: '20px !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>Notes</FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Add any relevant notes regarding this number block.
                    </Text>
                </Box>
                <Box flex="1" maxWidth="100%">
                    <Box
                        sx={{
                            display: 'flex',
                            width: '100%',
                            alignItems: 'flex-start',
                            paddingTop: '15px',
                        }}>
                        <VStack
                            width="100%"
                            minW={0}
                            alignItems="normal"
                            spacing={0}>
                            <Field name="internalNotes">
                                {({ field }) => (
                                    <AutoResizeTextArea
                                        {...field}
                                        placeholder="Relevant notes regarding adding number blocks"
                                        minRows={3}
                                        value={values.internalNotes || ''}
                                        onChange={(e) =>
                                            setFieldValue(
                                                'internalNotes',
                                                e.target.value,
                                            )
                                        }
                                        data-walkthroughid={ufNotesComment}
                                        borderColor={
                                            darkMode
                                                ? 'dark.tcap-borderGray'
                                                : null
                                        }
                                        bg={darkMode ? 'dark.bgDark' : '#FFF'}
                                        maxHeight="120px"
                                        overflow="auto"
                                    />
                                )}
                            </Field>
                        </VStack>
                    </Box>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Add any relevant notes regarding this number block."
                        ariaLabel="notes-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default NotesField;
